import { DependencyList, EffectCallback, useEffect, useRef } from 'react'
import isEqual from 'lodash/isEqual'

const useDeepCompareMemoize = (value: DependencyList) => {
  const mutableRef = useRef<DependencyList>()

  if (!isEqual(value, mutableRef.current)) {
    mutableRef.current = value
  }

  return mutableRef.current
}

const useEffectDeepCompare = (
  callback: EffectCallback,
  dependencies: DependencyList,
) => {
  useEffect(callback, useDeepCompareMemoize(dependencies))
}

export default useEffectDeepCompare
